var map = {
	"./cnn-money-x2.png": 2068,
	"./economist-x2.png": 2069,
	"./mashable-x2.png": 2070,
	"./tech-crunch-x2.png": 2071,
	"./thenewyorker-x2.png": 2072,
	"./thrillist-x2.png": 2073,
	"./time-x2.png": 2074,
	"./usa-today-x2.png": 2075
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2290;